import { useState } from "react";
import { Icon } from "@mui/material";
import { Box, Modal, Typography } from "@maysoft/common-component-react";

import { ChannelPagingType } from "../../constants/enums";
import useStrings from "../../hooks/useStrings";
import TableMember from "./tableMember";

const DialogMemberInChannel = (props: { totalMembers: number; type: ChannelPagingType; discussionGroupId: string }) => {
    const Strings = useStrings();
    const [openPopupMember, setOpenPopupMember] = useState<boolean>(false);

    return (
        <>
            {props.totalMembers > 0 && (
                <Box
                    style={{
                        display: "flex",
                        cursor: "pointer",
                        alignItems: "center",
                    }}
                    onClick={() => setOpenPopupMember(true)}
                >
                    <Icon sx={{ fontWeight: "bold", marginRight: 1 }}>people</Icon>
                    <Typography variant="button" color="secondary" fontWeight="bold">
                        {`(${props.totalMembers}) ${Strings.MEMBER.MEMBER}`}
                    </Typography>
                </Box>
            )}

            <Modal
                fullWidth
                maxWidth="sm"
                visible={openPopupMember}
                title={Strings.MEMBER.LIST_MEMBER}
                onClose={() => {
                    setOpenPopupMember(false);
                }}
            >
                <Box sx={{ padding: "16x" }}>
                    <TableMember type={props.type} discussionGroupId={props.discussionGroupId} />
                </Box>
            </Modal>
        </>
    );
};

export default DialogMemberInChannel;
